module.exports = __webpack_public_path__ + "static/media/checkbox-marked-circle.bd48bf2d.webp";